import React from 'react';
import "./ItemDetails.css"

const ItemDetails = ({ data, onChange, onNext, onDiscard }) => {
    const { name, description } = data;

    const handleInputChange = (e, field) => {
        onChange({ ...data, [field]: e.target.value });
    };

    const handleDiscard = () => {
        onDiscard();
    };

    return (
        <div className="item-details">
            <h2>Details</h2>
            <hr />
            <div className="form-group">
                <label>Name of the item</label>
                <input
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => handleInputChange(e, 'name')}
                />
            </div>
            <div className="form-group">
                <label>Description</label>
                <textarea
                    className="form-control"
                    value={description}
                    onChange={(e) => handleInputChange(e, 'description')}
                    maxLength={240}
                    rows={3}
                />
            </div>
            <div className="button-group">
                <button
                    type="button"
                    className={`btn btn-secondary ${name !== "" || description !== "" ? "" : "d-none"}`}
                    onClick={handleDiscard}
                >
                    Discard
                </button>
                <button
                    type="button"
                    className={`btn btn-primary ${name !== "" && description !== "" ? "" : "disabled"}`}
                    onClick={onNext}
                    disabled={name === "" || description === ""}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default ItemDetails;
